module.exports = __webpack_public_path__ + "static/img/ML01.0ff5763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/ML01.jpg
// module id = RrXV
// module chunks = 9